import {PaginationDto} from "../../common/dto/PaginationDto";

export class WeChatMessageTemplateSearchCondition extends PaginationDto {
    code: string = '';
    name: string = '';
}